// extracted by mini-css-extract-plugin
export var focusVisible = "y3Dme1mJRCxOjlxFDn4n";
export var icon = "AB82fSmdWwlzKewHQZZd";
export var inline = "f0cphwY0uCFdgMjHPtl9";
export var inlineText = "_pJl9Dh0K3jujdNUTbl9";
export var removePaddingLeft = "aBAWrwMc0ap5oK2XhWwQ";
export var removePaddingRight = "koCcxzLMBvKBHWbhLxtA";
export var removeSidePadding = "gsX_BGR7yDUImFRw72jS";
export var root = "_7LXqkMuGPsUd0UjZaWat";
export var text = "N5tMjyjpdycN1j6TedWQ";